module.exports = __webpack_public_path__ + "img/spray.b7ba3758.svg";